import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { DataShareService } from '@shared/services/data-share.service';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { NavService } from '@shared/services/nav.service';
import { SessionService } from '@shared/services/session.service';

@Component({
  selector: 'aaos-resident-enrollment-portal',
  templateUrl: './resident-enrollment-portal.component.html',
  styleUrls: ['./resident-enrollment-portal.component.scss']
})
export class ResidentEnrollmentPortalComponent implements OnInit, AfterViewInit {

  isAuthorized: boolean;
  isLoggedIn: boolean;
  dataIsLoaded = false;

  constructor(private dataShareService: DataShareService,
      private enrollmentService: EnrollmentService,
      private authService: AuthService,
      private navService: NavService,
      private sessionService: SessionService) { }

  ngOnInit() {
    this.isLoggedIn = this.sessionService.checkLoggedInCookie();
    if (!this.isLoggedIn) {
      this.navService.logintoAaos();
      this.sessionService.setLoggedInCookie();
    }
  }

  ngAfterViewInit(): void {
    this.isLoggedIn = this.sessionService.checkLoggedInCookie();
    if (this.isLoggedIn) {
    this.enrollmentService.getInstitutionInformation().subscribe(response => {
      this.isAuthorized = this.authService.isAuthorized();
        this.dataShareService.changeMessage(response.institutionName);
        this.dataIsLoaded = true;
      });
    }
  }


}
